var defaultTemplates = {
  labelText: function labelText(_ref) {
    var name = _ref.name;
    return name;
  }
};
export default defaultTemplates;